import { Spinner } from 'flowbite-react';
import { useSearchParams } from 'react-router-dom';

import { useCourtTimings } from '@/features/courts/hooks/sports/dodgeball/use-court-timings';
import { useActionCable } from '@/lib/action-cable';
import type { Court } from '@/types/api';

import { TeamInfo } from './components/team-info';
import { TimingInfo } from './components/timing-info';

export const DodgeballDisplay = ({ court }: { court: Court }) => {
  const [searchParams] = useSearchParams();
  const cable = useActionCable();
  const { matchData, penaltyData, timingData } = useCourtTimings(
    court.id,
    cable,
  );

  const inverted = searchParams.has('inverted');

  if (!(matchData && penaltyData && timingData)) {
    return (
      <div className="flex h-screen w-screen items-center justify-center">
        <Spinner />
      </div>
    );
  }

  const { config, state } = matchData;

  const swapped = inverted ? !state.swapped : state.swapped;

  return (
    <div className="flex h-screen w-screen flex-col items-center justify-between overflow-hidden font-display leading-none">
      <TimingInfo
        matchConfig={config}
        matchState={state}
        timings={timingData}
        homePenalties={swapped ? penaltyData.awayTeam : penaltyData.homeTeam}
        awayPenalties={swapped ? penaltyData.homeTeam : penaltyData.awayTeam}
      />
      <div className="flex w-full justify-between border-t px-[5vw] py-[2vh]">
        <TeamInfo
          score={swapped ? state.scores.away_team : state.scores.home_team}
          team={swapped ? matchData.away_team : matchData.home_team}
        />
        <TeamInfo
          score={swapped ? state.scores.home_team : state.scores.away_team}
          team={swapped ? matchData.home_team : matchData.away_team}
          reverse
        />
      </div>
    </div>
  );
};
